import { render } from "./Prestige.vue?vue&type=template&id=640e7904"
import script from "./Prestige.vue?vue&type=script&lang=js"
export * from "./Prestige.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/Prestige.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "640e7904"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('640e7904', __exports__)) {
    api.reload('640e7904', __exports__)
  }
  
  module.hot.accept("./Prestige.vue?vue&type=template&id=640e7904", () => {
    api.rerender('640e7904', render)
  })

}


export default __exports__